import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Media} from 'kpc';

var _$tmp0 = {
    'name': '参考图.png',
    'type': 'image',
    'showNameTooltip': true,
    'src': 'https://images.unsplash.com/photo-1495567720989-cebdbdd97913?auto=format&fit=crop&w=640&q=80'
};
var _$tmp1 = {
    'name': '产品预告.mp4',
    'type': 'video',
    'showNameTooltip': true,
    'src': 'https://www.w3schools.com/html/mov_bbb.mp4',
    'poster': 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=640&q=80'
};
var _$tmp2 = {
    'name': '播客片段.mp3',
    'type': 'audio',
    'showNameTooltip': true,
    'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Media, _$tmp0),
        _$cc(Media, _$tmp1),
        _$cc(Media, _$tmp2)
    ], 4, 'media-demo-basic');
};